import request from '@/utils/request'

export function selectBorderlessCarvingSet(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/borderlessCarvingSet/selectBorderlessCarvingSet?access=${data}`,
        method: 'post',
       // data,
    })
}

export function upDateBorderlessCarvingSet(data) {
    return request({
        url: `api/serviceCenter/borderlessCarvingSet/upDateBorderlessCarvingSet`,
        method: 'post',
        data,
    })
}

export function bathDeleteBorderlessCarving(data) {
    return request({
        url: `api/serviceCenter/borderlessCarvingSet/bathDeleteBorderlessCarving`,
        method: 'post',
        data,
    })
}
